export class ShipmentReportEmpViewModel{
    picking: number = 0;
    transferring: number = 0;
    transferReturning: number = 0;
    delivering: number = 0;
    returning: number = 0;
    pickupComplete: number = 0;
    deliveryComplete: number = 0;
    returnComplete: number = 0;
    waitingToTransfer: number = 0;
    assignEmployeePickup: number = 0;
}